import React from 'react'
import Link from 'next/link'
import dynamic from 'next/dynamic'
import PropTypes from 'prop-types'
import { useRouter } from 'next/router'

import MyImage from 'shared/components/myImage'
import logo from '@assets/images/logo.svg'
import ArrowLeft from 'assets/images/icon/arrow-left.svg'
import styles from './style.module.scss'
import useWindowSize from '@shared/hooks/windowSize'

const ReelSlider = dynamic(() => import('@shared/components/reelSlider'), { ssr: false })
const AdsCode = dynamic(() => import('@shared/components/ads/adsCode'), { ssr: false })

function ReelMain({ seoData, isMobileWebView, hideLogo = false, className }) {
  const router = useRouter()
  const [windowSize] = useWindowSize()
  // setPreviewMode(true)
  return (
    <div className={`${styles.reelsBody} ${className || ''} d-flex d-md-block justify-content-between flex-column`}>
      {!hideLogo && (
        <div className={`${styles.reelsHeader} text-center`}>
          <Link href="/" className="d-inline-block">
            <MyImage className={`${styles.reelsLogo} w-fit`} src={logo} alt="logo" width="150" />
          </Link>
        </div>
      )}
      {/* <div className="ratio ratio-16x9" style={{'--bs-aspect-ratio': }}> */}
      <div
        className={`${styles.reelsMain} ${isMobileWebView ? styles.isMobileWebView : ''} ${
          hideLogo ? styles.noLogo : ''
        } position-relative`}
      >
        {!isMobileWebView && (
          <button
            onClick={() => (window.history.length > 2 ? router.back() : router.push('/?tab=v'))}
            className={`${styles.reelsBack} position-absolute d-flex align-items-center justify-content-center rounded-circle border-0 p-2`}
          >
            <MyImage src={ArrowLeft} alt="ArrowLeft" height={25} width={25} />
          </button>
        )}
        <ReelSlider seoData={seoData} windowSize={windowSize} />
      </div>
      {!isMobileWebView && windowSize < 767 && (
        <AdsCode
          slotId="23148549803"
          adIdDesktop="Crictracker_New_Video_Mobile_Sticky_320x50"
          id="reel-mobile-sticky"
          className={'text-center bg-transparent'}
          dimensionDesktop={[320, 50]}
          enableRefresh={false}
        />
      )}
      {/* </div> */}
    </div>
  )
}
ReelMain.propTypes = {
  seoData: PropTypes.object,
  isMobileWebView: PropTypes.bool,
  hideLogo: PropTypes.bool,
  className: PropTypes.string
}
export default ReelMain
